import { render } from "./SaludOura.vue?vue&type=template&id=a6bd3696&scoped=true"
import script from "./SaludOura.vue?vue&type=script&lang=js"
export * from "./SaludOura.vue?vue&type=script&lang=js"

import "./SaludOura.vue?vue&type=style&index=0&id=a6bd3696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bd3696"]])

export default __exports__